import React from 'react'
import NavigationBar from '../components/NavigationBar'
import PostForm from '../components/posts/PostForm'

function CreatePost() {
  return (
    <div>
        <NavigationBar/>
        <PostForm/>
    </div>
  )
}

export default CreatePost